<template>
  <div ref="root" class="sp-provider-card-attributes">
    <slot />
  </div>
</template>

<script setup>
import { useTemplateRef } from "vue";
import { useDefaults } from "#ce/composables/useDefaults";

const root = useTemplateRef("root");
const props = defineProps({});

useDefaults(props, root, "SpProviderCardAttributes");
</script>
